import { RouteType } from "types/RouteType";
import dashboardRoute from "./Dashboard/AccountingDashboard.Route";
import purchasesRoute from "./Purchases/Purchases.Route";
import salesRoute from "./Sales/Sales.Route";
import paymentsRoute from "./Payments/Payments.Route";
// import costCodeRoute from "./CostCode/costCode.Route";
import holidayScheduleRoute from "./HolidaySchedule/holidaySchedule.Route";
import poConversionRoute from "./po-conversion/POConversion.Route";
import invoiceConversionRoute from "./invoice-conversion/InvoiceConversion.Route";
import invoiceDetailRoute from "./invoice-detail/InvoiceDetail.Route";

const accountingRoutesList: RouteType[] = [
  dashboardRoute,
  purchasesRoute,
  salesRoute,
  paymentsRoute,
  poConversionRoute,
  invoiceConversionRoute,
  invoiceDetailRoute,
  // costCodeRoute,
  ...holidayScheduleRoute,
];

export default accountingRoutesList;
